/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Settings_ChangedInputs */

const en_us2_club_settings_changed = /** @type {(inputs: Club_Settings_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The admin just changed the rules. Check them again before joining.`)
};

const pt_br2_club_settings_changed = /** @type {(inputs: Club_Settings_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O admin acabou de mudar as regras. Confira de novo antes de entrar.`)
};

const es_419_club_settings_changed = /** @type {(inputs: Club_Settings_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El admin acaba de cambiar las reglas. Revísalas otra vez antes de unirte.`)
};

const pt_pt2_club_settings_changed = /** @type {(inputs: Club_Settings_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O admin acabou de alterar as regras. Revê-as antes de entrar.`)
};

const fr_fr2_club_settings_changed = /** @type {(inputs: Club_Settings_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'admin vient de changer les règles. Relis-les avant de rejoindre.`)
};

const de_de2_club_settings_changed = /** @type {(inputs: Club_Settings_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Admin hat gerade die Regeln geändert. Prüf sie noch einmal, bevor du beitrittst.`)
};

const it_it2_club_settings_changed = /** @type {(inputs: Club_Settings_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'admin ha appena cambiato le regole. Rileggile prima di entrare.`)
};

/**
* | output |
* | --- |
* | "The admin just changed the rules. Check them again before joining." |
*
* @param {Club_Settings_ChangedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_settings_changed = /** @type {((inputs?: Club_Settings_ChangedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Settings_ChangedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_settings_changed(inputs)
	if (locale === "es-419") return es_419_club_settings_changed(inputs)
	if (locale === "pt-PT") return pt_pt2_club_settings_changed(inputs)
	if (locale === "fr-FR") return fr_fr2_club_settings_changed(inputs)
	if (locale === "de-DE") return de_de2_club_settings_changed(inputs)
	if (locale === "it-IT") return it_it2_club_settings_changed(inputs)
	return en_us2_club_settings_changed(inputs)
});
export { club_settings_changed as "club.settings_changed" }